import { render, staticRenderFns } from "./BtnCloseTimed.vue?vue&type=template&id=5a010b73"
import script from "./BtnCloseTimed.vue?vue&type=script&lang=js"
export * from "./BtnCloseTimed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports